import { readVersion } from "@/lib/version/read-version";

export const VERSION = readVersion();
